import cloneDeep from 'lodash.clonedeep';
import { setQueryString, getQueryString } from '@/utils/UrlUtils';

const INITIAL_STATE = {
  currentPage: 1,
  paymentAmount: '',
  hasNominatedCard: null,
};

export default {
  namespaced: true,

  state: cloneDeep(INITIAL_STATE),

  mutations: {
    resetAll(state) {
      Object.assign(state, cloneDeep(INITIAL_STATE));
    },

    updatePaymentAmount(state, data) {
      state.paymentAmount = data;
    },

    updateCurrentStep(state, data) {
      state.currentPage = data;

      if (Number(getQueryString('step')) !== Number(data)) {
        setQueryString('step', data);
      }
    },

    updateHasNominatedCard(state, data) {
      state.hasNominatedCard = data;
    },
  },

  getters: {
    getCurrentStep: (state) => {
      return state.currentPage;
    },

    getPaymentAmount: (state) => {
      return state.paymentAmount;
    },

    getHasNominatedCard: (state) => {
      return state.hasNominatedCard;
    },
  },
};
